export const dummyParents = {
  data: [
    {
      id: "1",
      name: "Karan Lamba",
      email: "karan@test.com",
      phone: "9999999999",
      status: 1,
      createdOn: "2026-03-01",

      children: [
        {
          id: "11",
          name: "Aarav Lamba",
          dob: "2015-01-01",
          grade: "5",
          school: "DPS",
          emergencyContact: "Mother",
          emergencyPhone: "8888888888",
        },
      ],

      addresses: [
        {
          id: "101",
          type: "Home",
          address: "Delhi",
          landmark: "Near Metro",
          pincode: "110001",
          lat: "28.6139",
          lng: "77.209",
        },
      ],
    },
    {
      id: "2",
      name: "Rahul Sharma",
      email: "rahul@test.com",
      phone: "8888888888",
      status: 0,
      createdOn: "2026-03-05",

      children: [],

      addresses: [],
    },
  ],
  total: 2,
};